import windowsStore from './app-image-windows-store-spotlight';
import win11StartMenuLight from './app-image-win11-start-menu-light';
import win11StartMenuDark from './app-image-win11-start-menu-dark';
import win10StartMenuLight from './app-image-win10-start-menu-light';
import win10StartMenuDark from './app-image-win10-start-menu-dark';
import winProngDark from './app-image-win-prong-dark';
import winProngLight from './app-image-win-prong-light';

export const appImageAdStartTemplates = [
  win11StartMenuLight,
  win11StartMenuDark,
  win10StartMenuLight,
  win10StartMenuDark,
  winProngLight,
  winProngDark,
  windowsStore,
];

export const appImageAdTemplates = [
  winProngLight,
  winProngDark,
  windowsStore,
];
